module.exports = "<div class=\"pal\">\n</div>\n"